import React from 'react';
import { Row, Col, Grid } from 'antd';

import { Header } from './Header';
import { useEwaJdsD86Context } from '../context';
import { useGetCustomReportResults } from '@/hooks';
import { buildResultPdfSections } from './Steps/Results/helpers';
import { DIRECTION } from '@/components/ui/StepsNavigation/types';
import { StepsNavigation } from '@/components/ui/StepsNavigation';
import { useApplicationContext } from '@/context/v1/Application/context';
import * as S from './styles';

const { useBreakpoint } = Grid;

export function Report(): JSX.Element {
	const breakpoints = useBreakpoint();
	const { organization, company } = useApplicationContext();
	const {
		isEwa,
		steps,
		currentStep,
		ewaJdsD86,
		customReport,
		original_custom_report_result_id,
		handleStepNagivationClick
	} = useEwaJdsD86Context();

	const { data: result } = useGetCustomReportResults({
		company_id: company?.id,
		report_id: customReport.id,
		file_id: ewaJdsD86?.file_id,
		organization_id: organization?.id,
		custom_report_result_id: ewaJdsD86.result_id,
		original_custom_report_result_id,
		selected_pdf_sections: buildResultPdfSections(isEwa)
	});

	const isConsolidated = Boolean(result.consolidated);

	return (
		<Row justify="center">
			<Col xs={24}>
				<Header />
			</Col>
			<Col span={24} style={{ marginTop: '2rem' }}>
				<Row justify="center" gutter={[16, 0]}>
					<Col xs={24} xxl={4}>
						<StepsNavigation
							steps={steps}
							currentStep={currentStep}
							isComplete={ewaJdsD86.is_completed}
							isConsolidated={isConsolidated}
							onStepNagivationClick={handleStepNagivationClick}
							direction={!breakpoints.xxl ? DIRECTION.HORIZONTAL : DIRECTION.VERTICAL}
						/>
					</Col>
					<S.ContainerStep xs={24} xxl={18} $isSmallScreen={`${breakpoints.lg}`}>
						{steps[currentStep]?.component}
					</S.ContainerStep>
				</Row>
			</Col>
		</Row>
	);
}
